import axios from 'axios';
import i18next from 'i18next';
import { downloadBlobResponse } from '../../util/downloadUtils';

let headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/pdf'
}

export const exportDailyDishData = (request, toastManager) => () => {
    return axios.post('/v1/report/menu', request, {
        headers: headers,
        responseType: 'blob'
    })
        .then(response => {
            handleContentDisposition(response);
            toastManager.add(i18next.t("export_success"), {
                appearance: 'success', autoDismiss: true, autoDismissTimeout: 3000
            })
            return response
        })
        .catch(async (err) => {
            if (err.response.status !== 200) {
                const error = JSON.parse(await err.response.data.text());
                toastManager.add(i18next.t(error.message), {
                    appearance: 'error', autoDismiss: true, autoDismissTimeout: 3000
                })
            } else {
            }
            return err.response
        })
}


/* REPORT DAILY,WEEKLY,CUSTOM */

export const getExportMacronutrients = (request, toastManager) => () => {
    return axios.post('/v1/report/macronutrients', request, {
        headers: headers,
        responseType: 'blob'
    })
        .then(response => {
            handleContentDisposition(response);
            toastManager.add(i18next.t("export_success"), {
                appearance: 'success', autoDismiss: true, autoDismissTimeout: 3000
            })
            return response
        })
        .catch(async (err) => {
            if (err.response.status !== 200) {
                const error = JSON.parse(await err.response.data.text());
                toastManager.add(i18next.t(error.message), {
                    appearance: 'error', autoDismiss: true, autoDismissTimeout: 3000
                })
            } else {
            }
            return err.response
        })
}

export const getExportCalories = (request, toastManager) => () => {
    return axios.post(`/v1/report/calories`, request, {
        headers: headers,
        responseType: 'blob'
    })
        .then(response => {
            handleContentDisposition(response);
            toastManager.add(i18next.t("export_success"), {
                appearance: 'success', autoDismiss: true, autoDismissTimeout: 3000
            })
            return response
        })
        .catch(async (err) => {
            if (err.response.status !== 200) {
                const error = JSON.parse(await err.response.data.text());
                toastManager.add(i18next.t(error.message), {
                    appearance: 'error', autoDismiss: true, autoDismissTimeout: 3000
                })
            } else {
            }
            return err.response
        })
}

export const getExportAllData = (request, toastManager) => () => {
    return axios.post(`/v1/report/all`, request, {
        headers: headers,
        responseType: 'blob'
    })
        .then(response => {
            handleContentDisposition(response);
            toastManager.add(i18next.t("export_success"), {
                appearance: 'success', autoDismiss: true, autoDismissTimeout: 3000
            })
            return response
        })
        .catch(async (err) => {
            if (err.response.status !== 200) {
                const error = JSON.parse(await err.response.data.text());
                toastManager.add(i18next.t(error.message), {
                    appearance: 'error', autoDismiss: true, autoDismissTimeout: 3000
                })
            } else {
            }
            return err.response
        })
}

/* REPORT MEAL */

export const exportNutrientDataForMeal = (mealId, toastManager) => () => {
    return axios.post(`/v1/report/meal/all`, mealId, {
        headers: headers,
        responseType: 'blob'
    })
        .then(response => {
            handleContentDisposition(response);
            toastManager.add(i18next.t("export_success"), {
                appearance: 'success', autoDismiss: true, autoDismissTimeout: 3000
            })
            return response
        })
        .catch(async (err) => {
            if (err.response.status !== 200) {
                const error = JSON.parse(await err.response.data.text());
                toastManager.add(i18next.t(error.message), {
                    appearance: 'error', autoDismiss: true, autoDismissTimeout: 3000
                })
            } else {
            }
            return err.response
        })
}

/* REPORT USER */

export const getExportUserMenus = (data, toastManager) => () => {
    return axios.post(`/v1/report/user/menus`, data, {
        headers: headers,
        responseType: 'blob'
    })
        .then(response => {
            handleContentDisposition(response);
            toastManager.add(i18next.t("export_success"), {
                appearance: 'success', autoDismiss: true, autoDismissTimeout: 3000
            })
            return response
        })
        .catch(async (err) => {
            if (err.response.status !== 200) {
                const error = JSON.parse(await err.response.data.text());
                toastManager.add(i18next.t(error.message), {
                    appearance: 'error', autoDismiss: true, autoDismissTimeout: 3000
                })
            } else {
            }
            return err.response
        })
}

export const getExportUserMenu = (data, toastManager) => () => {
    return axios.post(`/v1/report/menu`, data, {
        headers: headers,
        responseType: 'blob'
    })
        .then(response => {
            handleContentDisposition(response);
            toastManager.add(i18next.t("export_success"), {
                appearance: 'success', autoDismiss: true, autoDismissTimeout: 3000
            })
            return response
        })
        .catch(async (err) => {
            if (err.response.status !== 200) {
                const error = JSON.parse(await err.response.data.text());
                toastManager.add(i18next.t(error.message), {
                    appearance: 'error', autoDismiss: true, autoDismissTimeout: 3000
                })
            } else {
            }
            return err.response
        })
}

export const getExportUser = (request, toastManager) => () => {
    return axios.post('/v1/report/user', request, {
        headers: headers,
        responseType: 'blob'
    })
        .then(response => {
            handleContentDisposition(response);
            toastManager.add(i18next.t("export_success"), {
                appearance: 'success', autoDismiss: true, autoDismissTimeout: 3000
            })
            return response
        })
        .catch(async (err) => {
            if (err.response.status !== 200) {
                const error = JSON.parse(await err.response.data.text());
                toastManager.add(i18next.t(error.message), {
                    appearance: 'error', autoDismiss: true, autoDismissTimeout: 3000
                })
            } else {
            }
            return err.response
        })
}

/* REPORT FOOD CATEGORY */

export const getExportFoodCategory = (request, toastManager) => () => {
    return axios.post('/v1/report/category', request, {
        headers: headers,
        responseType: 'blob'
    })
        .then(response => {
            handleContentDisposition(response);
            toastManager.add(i18next.t("export_success"), {
                appearance: 'success', autoDismiss: true, autoDismissTimeout: 3000
            })
            return response
        })
        .catch(async (err) => {
            if (err.response.status !== 200) {
                const error = JSON.parse(await err.response.data.text());
                toastManager.add(i18next.t(error.message), {
                    appearance: 'error', autoDismiss: true, autoDismissTimeout: 3000
                })
            } else {
            }
            return err.response
        })
}

/*  REPORT FOR GENERAL DATA */

export const getGeneralExport = (request, toastManager) => () => {
    return axios.post(`/v1/report/general/xlsx`, request, {
        headers: {
            'Accept': 'application/octet-stream',
            'Access-Control-Expose-Headers': 'Content-Disposition'
        },
        responseType: 'blob'
    })
        .then(response => {
            handleContentDisposition(response);
            toastManager.add(i18next.t("export_success"), {
                appearance: 'success', autoDismiss: true, autoDismissTimeout: 3000
            })
            return response
        })
        .catch(async (err) => {
            if (err.response.status !== 200) {
                const error = JSON.parse(await err.response.data.text());
                toastManager.add(i18next.t(error.message), {
                    appearance: 'error', autoDismiss: true, autoDismissTimeout: 3000
                })
            } else {
            }
            return err.response
        })
}

/*  REPORT FOR FOOD QUANTITY*/

export const getExportFoodQuantity = (request, toastManager) => () => {
    return axios.post(`/v1/report/quantity/xlsx`, request, {
        headers: {
            'Accept': 'application/octet-stream',
            'Access-Control-Expose-Headers': 'Content-Disposition'
        },
        responseType: 'blob'
    })
        .then(response => {
            handleContentDisposition(response);
            toastManager.add(i18next.t("export_success"), {
                appearance: 'success', autoDismiss: true, autoDismissTimeout: 3000
            })
            return response
        })
        .catch(async (err) => {
            if (err.response.status !== 200) {
                const error = JSON.parse(await err.response.data.text());
                toastManager.add(i18next.t(error.message), {
                    appearance: 'error', autoDismiss: true, autoDismissTimeout: 3000
                })
            } else {
            }
            return err.response
        })
}

export const handleContentDisposition = (response) => {
    downloadBlobResponse(response);
}